import { render } from "./PaiementPage.vue?vue&type=template&id=32c2b606&scoped=true"
import script from "./PaiementPage.vue?vue&type=script&lang=js"
export * from "./PaiementPage.vue?vue&type=script&lang=js"

import "./PaiementPage.vue?vue&type=style&index=0&id=32c2b606&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-32c2b606"]])

export default __exports__